import React from 'react'
import { Accordion } from 'react-bootstrap'

export default function PhysicalDocs({data}) {
  const [activeKey, setActiveKey] = React.useState("0");

  return (
    <>
      <section className="home-document-area physical-docs-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="home-document-img">
                <img src={data?.boxes[activeKey]?.img}  alt="Redefine"  loading="lazy"/>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="home-document-content">
                <h3 className="heading">{data?.head}</h3>
                <p>{data?.desc}</p>
                <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key ?? activeKey)}>
                  {data?.boxes?.map((item, index) => (
                    <Accordion.Item key={index} eventKey={`${index}`} className={activeKey === `${index}` ? "active-accordion" : ""}>
                      <Accordion.Header>{item?.head}</Accordion.Header>
                      <Accordion.Body>{item?.para}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}